import {
  DELIVERABLES_SET,
  DELIVERABLE_ADDED,
  DELIVERABLE_DELETED,
  DELIVERABLE_EDITED,
} from 'src/app/redux/redux-types';
import { reduxDeliverableTypes } from 'src/types';

export const deliverableDefaultState: reduxDeliverableTypes.StateType = {
  deliverableList: [],
};

export const deliverableReducer = (
  state = deliverableDefaultState,
  action: reduxDeliverableTypes.ActionType,
): reduxDeliverableTypes.StateType => {
  switch (action.type) {
    case DELIVERABLES_SET:
      return {
        ...state,
        deliverableList: action.payload,
      };
    case DELIVERABLE_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.deliverableList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        deliverableList: [action.payload, ...state.deliverableList],
      };
    case DELIVERABLE_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.deliverableList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        deliverableList: [
          ...state.deliverableList.slice(0, updateIndex),
          action.payload,
          ...state.deliverableList.slice(updateIndex + 1),
        ],
      };
    case DELIVERABLE_DELETED:
      return {
        ...state,
        deliverableList: state.deliverableList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
